import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FizickiObjekt } from '@app/shared/models/fizicki-objekt';
import {
  Item,
  ListView,
  ListViewProviderDirective,
  UIComponents
} from '@ntap/core';
import { first, map, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-odaberi-fizicki',
  templateUrl: './odabir-fizickog.html'
})
export class SelectFizickiComponent implements OnInit, AfterViewInit {
  @Output()
  itemSelected = new EventEmitter<FizickiObjekt[]>();

  @ViewChild(ListViewProviderDirective)
  listViewProvider: ListViewProviderDirective<ListView>;

  INIT_COMP_ID = UIComponents.LISTVIEW;
  currentViewName: string;
  currentViewState: object | null = null;
  currentViewStateFilter: object = {};
  currentViewClass: string;

  disabled$: Observable<boolean>;

  private selectedItems$: Observable<Item[] | null>;

  ngOnInit(): void {
    this.currentViewName = 'fizicki_objekti_pretraga';
    this.currentViewState = {};
    this.currentViewStateFilter = {};
  }

  public ngAfterViewInit(): void {
    this.selectedItems$ = this.listViewProvider.selectedItems$;
    this.disabled$ = this.selectedItems$.pipe(map((i) => !i || i.length == 0));
  }

  public selectItem() {
    this.selectedItems$
      .pipe(
        first(),
        tap((items) => {
          if (!!items && items.length > 0) {
            this.itemSelected.next(items as FizickiObjekt[]);
          }
        })
      )
      .subscribe();
  }
}
